module.exports = __webpack_public_path__ + "static/media/ask_algorithm.f43e1de4.png";